import React from 'react'
import classNames from 'classnames'

export const Avatar = ({
  organizationName,
  organizationPhotoUrl,
  className,
}: {
  organizationName: string
  organizationPhotoUrl?: string
  className?: string
}) => {
  return (
    <img
      className={classNames('block radius-round', className)}
      style={{ height: 32, width: 32 }}
      alt={organizationName}
      src={organizationPhotoUrl}
    />
  )
}
